import React from 'react';
import Card from 'src/components/common/Card.redesign';
import CardContainer from 'src/components/common/CardContainer.redesign';
import Assignment from 'src/models/dlcLease/Assignment';
import AssignmentCard from './AssignmentCard';

interface IAssignmentsListComponentProps {
    assignments: Assignment[];
    onUpdateAssignment: (assignment: Assignment) => void;
}

const AssignmentsList = (props: IAssignmentsListComponentProps) => {
    const processingCards = (obj: Assignment) => {
        return (
            <div key={obj.assign_no}>
                <AssignmentCard
                    assignment={obj}
                    onUpdateAssignment={props.onUpdateAssignment}
                />
            </div>
        );
    };

    const newCard = () => {
        return (
            <CardContainer>
                {(props.assignments?.length > 0) && props.assignments?.map(processingCards)}
                {(props.assignments === undefined || props.assignments?.length === 0) && (
                    <Card>
                        <div className="agreements-card">
                            <div style={{ textAlign: 'center' }}>
                                <p>No Assignments!</p>
                            </div>
                        </div>
                    </Card>
                )}
            </CardContainer>
        );
    };

    const headerList = () => {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0 1rem' }}>
                <div className="form-field" style={{ width: '10%' }}>Assign No</div>
                <div className="form-field" style={{ width: '10%' }}>Assign Type</div>
                <div className="form-field" style={{ width: '10%' }}>Ack. type</div>
                <div className="form-field" style={{ width: '25%' }}>Assignor</div>
                <div className="form-field" style={{ width: '25%' }}>Assignee</div>
                <div className="form-field" style={{ width: '10%' }}>State</div>
                <div className="form-field" style={{ width: '10%' }}>County</div>
            </div>
        );
    };

    return (
        <>
            {headerList()}
            {newCard()}
        </>
    );
};

export default AssignmentsList;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ProcessingAndMaintenance/AssignmentsList.tsx